if(typeof debounce>"u")var debounce=function(fn,wait){let t;return(...args)=>{clearTimeout(t),t=setTimeout(()=>fn.apply(this,args),wait)}};if(!customElements.get("theme-header")){class ThemeHeader extends HTMLElement{constructor(){super()}connectedCallback(){this.header_section=document.querySelector(".header-section"),this.menu=this.querySelector("#mobile-menu"),this.toggle=this.querySelector(".mobile-toggle-wrapper"),document.addEventListener("keyup",e=>{e.code&&e.code.toUpperCase()==="ESCAPE"&&(this.toggle.removeAttribute("open"),this.toggle.classList.remove("active"))}),this.classList.contains("header-sticky--active")&&document.body.classList.add("header-sticky--active"),this.toggle.querySelector(".mobile-toggle").addEventListener("click",e=>{this.toggle.classList.contains("active")?(e.preventDefault(),document.body.classList.remove("overflow-hidden"),this.toggle.classList.remove("active"),this.closeAnimation(this.toggle)):(document.body.classList.add("overflow-hidden"),setTimeout(()=>{this.toggle.classList.add("active")}))}),window.addEventListener("scroll",this.setStickyClass.bind(this),{passive:!0}),window.addEventListener("scroll",this.setHeaderOffset.bind(this),{passive:!0}),window.addEventListener("scroll",this.setHeaderHeight.bind(this),{passive:!0}),window.dispatchEvent(new Event("scroll")),document.querySelector(".announcement-bar-section")&&(window.addEventListener("scroll",this.setAnnouncementHeight(),{passive:!0}),window.dispatchEvent(new Event("resize"))),setTimeout(()=>{this.mobile_nav=document.querySelector(".header-mobile-navigation"),this.mobile_nav&&this.classList.contains("transparent--true")&&this.mobile_nav.classList.add("is-fixed")},100),this.menu.querySelectorAll("summary").forEach(summary=>summary.addEventListener("click",this.onSummaryClick.bind(this))),this.menu.querySelectorAll(".parent-link-back--button").forEach(button=>button.addEventListener("click",this.onCloseButtonClick.bind(this)))}setStickyClass(){if(this.classList.contains("header-sticky--active")){let offset=parseInt(this.getBoundingClientRect().top,10)+document.documentElement.scrollTop;this.classList.toggle("is-sticky",window.scrollY>=offset&&window.scrollY>0)}}setAnnouncementHeight(){let h=document.querySelector(".announcement-bar-section").clientHeight;document.documentElement.style.setProperty("--announcement-height",h+"px")}setHeaderOffset(){let h=this.header_section.getBoundingClientRect().top;document.documentElement.style.setProperty("--header-offset",h+"px")}setHeaderHeight(){let h=this.clientHeight;document.documentElement.style.setProperty("--header-height",h+"px")}onSummaryClick(event){const detailsElement=event.currentTarget.parentNode,parentMenuElement=detailsElement.closest(".link-container"),isOpen=detailsElement.hasAttribute("open");this.querySelector(".parent-link-back--button")&&(this.menu.scrollTop=0),setTimeout(()=>{detailsElement.classList.add("menu-opening"),parentMenuElement&&parentMenuElement.classList.add("submenu-open")},100)}onCloseButtonClick(event){event.preventDefault();const detailsElement=event.currentTarget.closest("details");this.closeSubmenu(detailsElement)}closeSubmenu(detailsElement){detailsElement.classList.remove("menu-opening"),this.closeAnimation(detailsElement)}closeAnimation(detailsElement){let animationStart;const handleAnimation=time=>{animationStart===void 0&&(animationStart=time),time-animationStart<400?window.requestAnimationFrame(handleAnimation):detailsElement.removeAttribute("open")};window.requestAnimationFrame(handleAnimation)}}customElements.define("theme-header",ThemeHeader)}if(!customElements.get("full-menu")){class FullMenu extends HTMLElement{constructor(){super(),this.submenus=this.querySelectorAll(".thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu")}connectedCallback(){if(!this.submenus.length)return;const _this=this;document.fonts.ready.then(function(){window.addEventListener("resize",debounce(function(){_this.resizeSubMenus()},100))})}resizeSubMenus(){this.submenus.forEach(submenu=>{submenu.querySelectorAll(":scope >.menu-item-has-children>.sub-menu").forEach(sub_submenu=>{let w=sub_submenu.offsetWidth,l=sub_submenu.parentElement.getBoundingClientRect().left+sub_submenu.parentElement.offsetWidth;w+l>window.innerWidth?sub_submenu.parentElement.classList.add("left-submenu"):sub_submenu.parentElement.classList.contains("left-submenu")&&sub_submenu.parentElement.classList.remove("left-submenu")})})}}customElements.define("full-menu",FullMenu)}
//# sourceMappingURL=/s/files/1/0668/5127/4799/t/3/assets/header.js.map?v=1738820854

let scrollTimeout;

window.addEventListener('scroll', function() {
  // If no scroll has been detected for 2 seconds, add the class
  if (!scrollTimeout) {
    scrollTimeout = setTimeout(function() {
      document.body.classList.add('scrolling-sticky');
    }, 2000);  // 2 seconds (2000ms) delay
  }
});





// secure web
function extractTimerDate(i){
    const year = i.getAttribute("data-countdown-year");
    const month = i.getAttribute("data-countdown-month").padStart(2, '0');
    const day = i.getAttribute("data-countdown-day").padStart(2, '0');
    const hour = (i.getAttribute("data-countdown-hour") || "00").padStart(2, '0');
    const minutes = (i.getAttribute("data-countdown-mintues") || "00").padStart(2, '0'); // typo in "mintues"
    const seconds = "00"; // default seconds
  
    const isoString = `${year}-${month}-${day}T${hour}:${minutes}:${seconds}`;
   return getTimeLeft(isoString);
}
  
function getTimeLeft(targetDateStr = '2025-07-23T00:00:00') {
  // Parse the target date with time zone using Date constructor
  const targetDate = new Date(targetDateStr);
  const now = new Date();

  // Get difference in milliseconds
  const diffMs = targetDate - now;

  // If the target date is in the past
  if (diffMs <= 0) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };
  }

  const totalSeconds = Math.floor(diffMs / 1000);
  const days = Math.floor(totalSeconds / (3600 * 24));
  const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return {
    days: String(days).padStart(2, '0'),
    hours: String(hours).padStart(2, '0'),
    minutes: String(minutes).padStart(2, '0'),
    seconds: String(seconds).padStart(2, '0')
  };
}

function updateCountdown() {
  const timer = document.querySelectorAll(".countdown-banner--timer");
  if (timer.length === 0) {
    return;
  }
  
  for (let i of timer) {
    let left = getTimeLeft();
    if( i.getAttribute('data-countdown-year') ){
      left = extractTimerDate(i);
    }

    if( i.querySelector(".days-number") ){
    i.querySelector(".days-number").innerText = left.days;
    i.querySelector(".hours-number").innerText = left.hours;
    i.querySelector(".minutes-number").innerText = left.minutes;
    i.querySelector(".seconds-number").innerText = left.seconds;
    }
  }
}
  
  
document.addEventListener('DOMContentLoaded', () => {
    updateCountdown();
    setInterval(() => updateCountdown(), 1000);
});
